import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { SidenavOption } from '@aid/core/types/interfaces';
import { User } from '@aid/core/types/classes';
import { Router } from '@angular/router';

@Component({
  selector: 'aid-sidenav',
  template: `
    <div
      class="sidenav aid-layout-column"
      [ngClass]="{ 'sidenav--collapsed': collapsed }"
    >
      <div class="full-height sidenav--scroll aid-layout-column">
        <mat-list>
          @for (option of sidenavOptions; track option; let first = $first) {
            <div>
              <mat-list-item
                *aidHasPermission="option.permissions"
                [disableRipple]="true"
                class=" sidenav__item--height"
                (click)="onOption(option.routerLink)"
                data-cy="test33"
                [ngClass]="{
                  'sidenav__item--active-route': active === option.routerLink,
                  'sidenav__item--border': first
                  }"
                matTooltip="{{ option.name | translate }}"
                matTooltipShowDelay="1000"
              >
                <div
                  class="sidenav__item--padding sidenav__item--no-select aid-layout-row aid-layout-align-start-center"
                  [ngClass]="{
                    'sidenav__item--select': active === option.routerLink
                    }"
                >
                  <mat-icon
                    class="sidenav__item-icon"
                    [svgIcon]="option.icon"
                  ></mat-icon>
                  <span
                    class="mat-subtitle-2"
                    [ngClass]="{ 'sidenav--collapsed': collapsed }"
                  >
                    {{ option.name | translate }}
                  </span>
                </div>
              </mat-list-item>
            </div>
          }
        </mat-list>
      </div>

      <div class="aid-layout-column">
        <mat-nav-list>
          <mat-divider></mat-divider>
          <mat-list-item class=" sidenav__close" (click)="collapse.emit()">
            <div class="aid-layout-row aid-flex aid-layout-align-end">
              <mat-icon [svgIcon]="collapsedIcon"></mat-icon>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  `,
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidenavComponent implements OnInit {
  @Input() collapsed: boolean | null = false;

  @Input() user: User | null = null;
  @Input() sidenavOptions: SidenavOption[] = [];
  @Input() active = '';
  @Output() collapse = new EventEmitter<void>();

  constructor(private router: Router) {}

  ngOnInit() {}

  get collapsedIcon() {
    return this.collapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left';
  }

  onOption(link: string) {
    this.router.navigate([link]);
  }
}
